import * as React from "react";
import type { SVGProps } from "react";
const SvgDocumentFileSettingHorizontalBottomLeft = (
  props: SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20 8.5h-3.5a2 2 0 0 1-2-2V3"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15 21h2a3 3 0 0 0 3-3V8.243a3 3 0 0 0-.879-2.122L16.88 3.88A3 3 0 0 0 14.757 3H7a3 3 0 0 0-3 3v4.949M11 20H7.5"
    />
    <circle
      cx={6}
      cy={20}
      r={1.5}
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5 15h3.5"
    />
    <circle
      cx={10}
      cy={15}
      r={1.5}
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgDocumentFileSettingHorizontalBottomLeft;
